import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Dashboard from '@/app/module/dashboard/component'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps
}

export default function DashboardPage({ match }: Props) {
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Dashboard - engageSPARK">
        <AuthHeader currentPage={PAGE.DASHBOARD.INDEX} />
        <TotpGuard>
          <Dashboard />
        </TotpGuard>
      </Layout>
      <Notifications />
    </AuthGuard>
  )
}
